// import { NavLink } from 'react-router-dom'
// import { useState, useEffect } from 'react'
// import {
//   LayoutGrid,
//   TrendingUp,
//   Shield,
//   User,
//   Layers,
//   Calendar,
//   Award,
//   CreditCard,
//   Wallet,
//   Bell,
//   Settings,
//   ArrowLeft,
//   ArrowRight,
//   Menu,
//   X,
// } from 'lucide-react'
// import logo from '../assets/favicon1.png'


// // export function DualonMark({ size = 32, color = '#33cb98', style = {} }: { size?: number; color?: string; style?: React.CSSProperties }) {
// //   const uid = useId().replace(/:/g, '')
// //   return (
// //     <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={style}>
// //       <defs>
// //         <linearGradient id={`dm-${uid}`} x1="0.1" y1="0" x2="0.9" y2="1">
// //           <stop offset="0" stopColor="#42d6a3" />
// //           <stop offset="1" stopColor={color} />
// //         </linearGradient>
// //       </defs>
// //       <rect x="7" y="14" width="7.2" height="20" rx="3.6" fill={`url(#dm-${uid})`} />
// //       <path d="M18.4 11 L40 21.9 L18.4 20.7 Z" fill={`url(#dm-${uid})`} stroke={`url(#dm-${uid})`} strokeWidth="2.4" strokeLinejoin="round" />
// //       <path d="M18.4 26.3 L40 24.1 L18.4 37 Z" fill={`url(#dm-${uid})`} stroke={`url(#dm-${uid})`} strokeWidth="2.4" strokeLinejoin="round" />
// //     </svg>
// //   )
// // }

// interface SidebarProps {
//   collapsed: boolean        // desktop collapsed/expanded rail state
//   onToggle: () => void      // desktop toggle handler
// }

// interface NavItem {
//   id: string
//   label: string
//   icon: React.ElementType
//   to: string
//   count?: string | number
//   alert?: boolean
// }

// interface NavSection {
//   title: string
//   items: NavItem[]
// }

// const NAV_GROUPS: NavSection[] = [
//   {
//     title: 'Overview',
//     items: [
//       { id: 'dashboard', icon: LayoutGrid, label: 'Dashboard', to: '/dashboard' },
//       { id: 'reports', icon: TrendingUp, label: 'Reports & Analytics', to: '/reports' },
//     ],
//   },
//   {
//     title: 'Manage',
//     items: [
//       { id: 'institutions', icon: Shield, label: 'Institutions', to: '/institutions', count: 186 },
//       { id: 'students', icon: User, label: 'Students', to: '/students', count: '24.3k' },
//       { id: 'syllabus', icon: Layers, label: 'Courses & Syllabus', to: '/courses' },
//       { id: 'exams', icon: Calendar, label: 'Exams & Results', to: '/exams' },
//       { id: 'certificates', icon: Award, label: 'Certificates', to: '/certificates' },
//     ],
//   },
//   {
//     title: 'Finance',
//     items: [
//       { id: 'payments', icon: CreditCard, label: 'Payments', to: '/payments' },
//       { id: 'commissions', icon: Wallet, label: 'Commissions', to: '/commissions', alert: true },
//     ],
//   },
//   {
//     title: 'System',
//     items: [
//       { id: 'notifications', icon: Bell, label: 'Notification Center', to: '/notifications' },
//       { id: 'config', icon: Settings, label: 'Configuration', to: '/configuration' },
//     ],
//   },
// ]

// export default function Sidebar({ collapsed, onToggle }: SidebarProps) {
//   const [isMobile, setIsMobile] = useState(() =>
//     typeof window !== 'undefined' ? window.innerWidth < 1024 : false
//   )
//   // Separate mobile drawer open state — completely independent of desktop `collapsed`
//   const [mobileOpen, setMobileOpen] = useState(false)

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024
//       setIsMobile(mobile)
//       // When crossing back to desktop, always close the mobile drawer
//       // so it never bleeds into the desktop layout
//       if (!mobile) setMobileOpen(false)
//     }
//     window.addEventListener('resize', handleResize)
//     return () => window.removeEventListener('resize', handleResize)
//   }, [])

//   // Desktop: derive visibility from `collapsed` prop from parent
//   // Mobile:  derive visibility from local `mobileOpen` state
//   const desktopCollapsed = !isMobile && collapsed
//   const mobileDrawerOpen = isMobile && mobileOpen

//   const sidebarWidth = isMobile ? 280 : collapsed ? 84 : 280

//   return (
//     <>
//       {/* ── Mobile Floating Hamburger Button ──────────────────────── */}
//       {isMobile && !mobileOpen && (
//         <button
//           onClick={() => setMobileOpen(true)}
//           className="fixed top-4 left-4 z-40 p-2.5 rounded-xl border flex items-center justify-center transition-all duration-200 active:scale-95 bg-[var(--glass)] border-[var(--glass-brd)] text-[var(--txt)]"
//           style={{
//             backdropFilter: 'blur(12px)',
//             WebkitBackdropFilter: 'blur(12px)',
//           }}
//         >
//           <Menu size={22} style={{ strokeWidth: '2px' }} />
//         </button>
//       )}

//       {/* ── Mobile Backdrop Overlay ────────────────────────────────── */}
//       {mobileDrawerOpen && (
//         <div
//           className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
//           onClick={() => setMobileOpen(false)}
//         />
//       )}

//       {/* ── Sidebar panel ─────────────────────────────────────────── */}
//       <aside
//         className={`
//           glass flex flex-col h-screen select-none shrink-0 overflow-hidden
//           border-t-0 border-b-0 border-l-0 border-r border-[var(--glass-brd)] shadow-none
//           transition-[width,transform] duration-300
//           ${isMobile
//             ? `fixed top-0 bottom-0 left-0 z-50 rounded-none ${mobileDrawerOpen ? 'translate-x-0' : '-translate-x-full'}`
//             : 'static'
//           }
//         `}
//         style={{
//           width: `${sidebarWidth}px`,
//           transitionTimingFunction: 'var(--ease)',
//         }}
//       >
//         {/* <div className={`flex items-center ${desktopCollapsed ? 'justify-center py-4 px-0' : 'justify-between py-4 px-6'}`}>
//           <div className="flex items-center gap-[14px]">
//             {desktopCollapsed ? (
//               <div className="w-13 h-13 overflow-hidden flex items-center justify-start rounded-lg select-none">
//                 <img
//                   src={logo}
//                   alt="Dualon Logo"
//                   className="h-18 min-w-[220px] max-w-none object-cover object-left select-none"
//                   style={{ marginLeft: '-15px', imageRendering: '-webkit-optimize-contrast' }}
//                 />
//               </div>
//             ) : (
//               <img
//                 src={logo}
//                 alt="Dualon"
//                 className="w-auto select-none"
//                 style={{
//                   height: isMobile ? '48px' : '64px',
//                   marginLeft: '-14px',
//                   objectFit: 'contain',
//                   objectPosition: 'left center',
//                   imageRendering: '-webkit-optimize-contrast',
//                   maxWidth: '100%',
//                 }}
//               />
//             )}
//           </div>
//           {/* X Close — mobile drawer only */}
//           {/* {isMobile && mobileDrawerOpen && (
//             <button
//               onClick={() => setMobileOpen(false)}
//               className="p-1.5 rounded-lg text-[var(--txt-2)] hover:text-[var(--txt)] transition-colors"
//             >
//               <X size={20} />
//             </button>
//           )}
//         </div> */}


//         {/* ── Logo & Mobile Close Button ────────────────────────── */}
// {/* <div className={`flex items-center ${desktopCollapsed ? 'justify-center py-6 px-0' : 'justify-between pt-7 pb-4 px-6'}`}>
//   <div className="flex items-center">
//     {desktopCollapsed ? (
//       <div className="w-10 h-10 flex items-center justify-center">
//         <img
//           src={logo}
//           alt="Dualon Logo"
//           className="h-8 w-8 object-contain"
//         />
//       </div>
//     ) : (
//       <div className="flex items-center gap-2 select-none">
//         <img
//           src={logo}
//           alt="Dualon Logo"
//           className="h-9 w-9 object-contain"
//           style={{ imageRendering: '-webkit-optimize-contrast' }}
//         />
//         <span
//           className="t-display no-sel font-black"
//           style={{
//             fontSize: '24px',
//             fontWeight: 900,
//             letterSpacing: '0.6px',
//             color: 'var(--txt)',
//             lineHeight: 1,
//           }}
//         >
//           DUALON
//         </span>
//       </div>
//     )}
//   </div>

//   {/* X Close — mobile drawer only */}
//   {/* {isMobile && mobileDrawerOpen && (
//     <button
//       onClick={() => setMobileOpen(false)}
//       className="p-1.5 rounded-lg text-[var(--txt-2)] hover:text-[var(--txt)] transition-colors"
//     >
//       <X size={20} />
//     </button>
//   )}
// </div> */}




// {/* ── Logo & Mobile Close Button ────────────────────────── */}
// <div className={`flex items-center ${desktopCollapsed ? 'justify-center py-6 px-0' : 'justify-between pt-7 pb-4 px-6'}`}>
//   <div className="flex items-center">
//     {desktopCollapsed ? (
//       <div className="w-10 h-10 flex items-center justify-center">
//         <img
//           src={logo}
//           alt="Dualon Logo"
//           className="h-8 w-8 object-none" 
//           style={{ imageRendering: 'auto' }}
//         />
//       </div>
//     ) : (
//       <div className="flex items-center gap-3 select-none">
//         <img
//           src={logo}
//           alt="Dualon Logo"
//           className="h-8 w-8 object-none"
//           style={{ imageRendering: 'auto' }}
//         />
//         <span
//           className="
//             no-sel inline-block text-[26px] font-[900] leading-none text-[var(--txt)] antialiased
//             font-['Montserrat','Proxima_Nova','Inter',sans-serif] 
//             tracking-[-0.4px] scale-x-[1.06] origin-left
//           "
//         >
//           DUALON
//         </span>
//       </div>
//     )}
//   </div>

//   {/* X Close — mobile drawer only */}
//   {isMobile && mobileDrawerOpen && (
//     <button
//       onClick={() => setMobileOpen(false)}
//       className="p-1.5 rounded-lg text-[var(--txt-2)] hover:text-[var(--txt)] transition-colors"
//     >
//       <X size={20} />
//     </button>
//   )}
// </div>
//         {/* ── Status indicator ─────────────────────────────────── */}
//         <div
//           className={`
//             mx-5 mb-4 px-[14px] py-[10px] rounded-xl
//             bg-[var(--glass)] border border-[var(--glass-brd)]
//             items-center gap-[10px]
//             ${desktopCollapsed ? 'hidden' : 'flex'}
//           `}
//         >
//           <span className="pulse-dot w-2 h-2 rounded-full shrink-0 bg-[#33cb98]" />
//           <span className="text-[12.5px] font-bold text-[var(--txt-2)]">
//             Super Admin · Live
//           </span>
//         </div>

//         {/* ── Nav sections ─────────────────────────────────────── */}
//         <nav className="flex-1 overflow-y-auto overflow-x-hidden scrollbar-none px-5 py-0">
//           {NAV_GROUPS.map((group) => (
//             <div key={group.title} className="mb-5">
//               <div className={`text-[11px] font-extrabold tracking-[0.8px] uppercase text-[var(--txt-3)] px-3 pb-[10px] ${desktopCollapsed ? 'hidden' : 'block'}`}>
//                 {group.title}
//               </div>

//               <div className="flex flex-col gap-1">
//                 {group.items.map((item) => (
//                   <NavLink
//                     key={item.id}
//                     to={item.to}
//                     end={item.to === '/dashboard'}
//                     className={({ isActive }) => `nav-item ${isActive ? 'on' : ''}`}
//                     style={{
//                       justifyContent: desktopCollapsed ? 'center' : 'flex-start',
//                       padding: desktopCollapsed ? '12px 0' : '11px 14px',
//                     }}
//                     title={desktopCollapsed ? item.label : ''}
//                     onClick={() => isMobile && setMobileOpen(false)}
//                   >
//                     <item.icon size={20} className="shrink-0" style={{ strokeWidth: '1.85px' }} />
//                     <span className={`flex-1 ml-1 ${desktopCollapsed ? 'hidden' : 'block'}`}>
//                       {item.label}
//                     </span>
//                     {item.count && (
//                       <span className={`text-[11.5px] font-bold text-[var(--txt-3)] ${desktopCollapsed ? 'hidden' : 'block'}`}>
//                         {item.count}
//                       </span>
//                     )}
//                   </NavLink>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </nav>

//         {/* ── Footer / Collapse ─────────────────────────────────── */}
//         <div className="p-5">
//           <div
//             className={`t-display relative overflow-hidden p-4 rounded-2xl mb-[14px] border border-[var(--glass-brd)] ${desktopCollapsed ? 'hidden' : 'block'}`}
//             style={{ background: 'linear-gradient(140deg, rgba(51, 203, 152, 0.18), rgba(153, 102, 255, 0.18))' }}
//           >
//             <div className="text-sm font-bold mt-2 text-[var(--txt)]">System healthy</div>
//             <div className="text-[11.5px] text-[var(--txt-2)] mt-1 leading-[1.45]">
//               99.98% uptime · all services operational
//             </div>
//           </div>

//           {/* Collapse toggle — desktop only */}
//           {!isMobile && (
//             <button
//               className="nav-item w-full"
//               onClick={onToggle}
//               style={{
//                 justifyContent: collapsed ? 'center' : 'flex-start',
//                 padding: '11px 14px',
//               }}
//             >
//               {collapsed ? (
//                 <ArrowRight size={20} style={{ strokeWidth: '1.85px' }} />
//               ) : (
//                 <>
//                   <ArrowLeft size={20} style={{ strokeWidth: '1.85px' }} />
//                   <span className="ml-1">Collapse</span>
//                 </>
//               )}
//             </button>
//           )}
//         </div>
//       </aside>
//     </>
//   )
// }







import { NavLink, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useAuth } from '@/app/hooks'
import { useLogoutMutation } from '@/features/auth/auth.api'
import { useGetStaffPermissionScopeQuery } from '@/features/staff/staff.api'
import {
  LayoutGrid,
  TrendingUp,
  Shield,
  User,
  Users,
  Layers,
  Calendar,
  Award,
  CreditCard,
  Wallet,
  Bell,
  ChevronLeft,
  ChevronRight,
  Menu,
  X,
  LogOut,
  Ticket,
  Smartphone,
} from 'lucide-react'
import logo from '../assets/favicon1.png'

interface SidebarProps {
  collapsed: boolean        // desktop collapsed/expanded rail state
  onToggle: () => void      // desktop toggle handler
}

interface NavItem {
  id: string
  label: string
  icon: React.ElementType
  to: string
  count?: string | number
  alert?: boolean
}

interface NavSection {
  title: string
  items: NavItem[]
}

const NAV_GROUPS: NavSection[] = [
  {
    title: 'Overview',
    items: [
      { id: 'dashboard', icon: LayoutGrid, label: 'Dashboard', to: '/dashboard' },
      { id: 'reports', icon: TrendingUp, label: 'Reports & Analytics', to: '/reports' },
    ],
  },
  {
    title: 'Manage',
    items: [
      { id: 'institutions', icon: Shield, label: 'Institutions', to: '/institutions', count: 186 },
      { id: 'students', icon: User, label: 'Students', to: '/students', count: '24.3k' },
      { id: 'syllabus', icon: Layers, label: 'Courses & Syllabus', to: '/courses' },
      { id: 'exams', icon: Calendar, label: 'Exams & Results', to: '/exams' },
      { id: 'certificates', icon: Award, label: 'Certificates', to: '/certificates' },
    ],
  },
  {
    title: 'Finance',
    items: [
      { id: 'payments', icon: CreditCard, label: 'Payments', to: '/payments' },
      { id: 'commissions', icon: Wallet, label: 'Commissions', to: '/commissions', alert: true },
      { id: 'coupons', icon: Ticket, label: 'Coupons', to: '/coupons' },
    ],
  },
  {
    title: 'System',
    items: [
      { id: 'staff', icon: Users, label: 'Staff Management', to: '/staff' },
      { id: 'notifications', icon: Bell, label: 'Notification Center', to: '/notifications' },
      { id: 'app-updates', icon: Smartphone, label: 'App Updates', to: '/app-updates' },
    ],
  },
]

function SidebarSkeleton({ desktopCollapsed }: { desktopCollapsed: boolean }) {
  const skeletonGroups = [
    { title: 'Overview', itemsCount: 2 },
    { title: 'Manage', itemsCount: 5 },
    { title: 'Finance', itemsCount: 3 },
    { title: 'System', itemsCount: 3 },
  ]

  return (
    <div className="animate-pulse space-y-5">
      {skeletonGroups.map((group, idx) => (
        <div key={idx} className="mb-5">
          {/* Section Header Placeholder */}
          <div 
            className={`
              h-3 bg-neutral-200/50 dark:bg-neutral-800/40 rounded transition-all duration-300 ease-[var(--ease)] origin-left mb-3
              ${desktopCollapsed ? 'opacity-0 max-h-0 overflow-hidden' : 'opacity-100 max-h-8 ml-3 w-16'}
            `}
          />

          <div className="flex flex-col gap-1">
            {[...Array(group.itemsCount)].map((_, i) => (
              <div
                key={i}
                className="flex items-center rounded-xl bg-transparent"
                style={{
                  justifyContent: desktopCollapsed ? 'center' : 'flex-start',
                  padding: desktopCollapsed ? '12px 0' : '11px 14px',
                }}
              >
                {/* Icon Placeholder */}
                <div className="w-5 h-5 bg-neutral-200/50 dark:bg-neutral-800/40 rounded-lg shrink-0" />
                
                {/* Label Placeholder */}
                <div
                  className={`
                    h-4 bg-neutral-200/50 dark:bg-neutral-800/40 rounded transition-all duration-300 ease-[var(--ease)] origin-left
                    ${desktopCollapsed ? 'opacity-0 max-w-0 ml-0 overflow-hidden' : 'flex-1 opacity-100 max-w-[120px] ml-3'}
                  `}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default function Sidebar({ collapsed, onToggle }: SidebarProps) {
  const navigate = useNavigate()
  const [logout, { isLoading: isLoggingOut }] = useLogoutMutation()

  const handleLogout = async () => {
    try {
      await logout().unwrap()
    } catch (err) {
      console.error('Logout request failed, clearing session locally anyway:', err)
    } finally {
      navigate('/login', { replace: true })
    }
  }

  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < 1024 : false
  )
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024
      setIsMobile(mobile)
      if (!mobile) setMobileOpen(false)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const desktopCollapsed = !isMobile && collapsed
  const mobileDrawerOpen = isMobile && mobileOpen
  const sidebarWidth = isMobile ? 300 : collapsed ? 84 : 300

  const { user, isAuthenticated, isInitializing } = useAuth()

  // Derive roles — same pattern used in every guard
  const isSuperAdmin = Boolean(
    user?.primaryRole?.includes('SUPER_ADMIN') ||
    user?.roles?.some((r) => r.includes('SUPER_ADMIN')),
  )
  // A staff user is any authenticated non-super-admin
  const isStaff = isAuthenticated && !isSuperAdmin

  // Only call the permissions API for actual staff members, not during init or for super admins
  const { data: permissionsResponse, isLoading: permissionsLoading } = useGetStaffPermissionScopeQuery(
    undefined,
    { skip: !isStaff || isInitializing },
  )
  const permissions = permissionsResponse?.data ?? []

  // Show skeleton while: (a) auth is still initialising, or (b) staff permissions haven't loaded yet
  const showSkeleton = isInitializing || (isStaff && permissionsLoading)

  // ── Permission → nav item mapping ─────────────────────────────────────────
  // Super admins see every item. Staff only see items covered by their permissions array.
  const hasPermission = (itemId: string): boolean => {
    if (isSuperAdmin) return true

    switch (itemId) {
      case 'dashboard':
        // Dashboard is always visible to any authenticated user
        return true
      case 'reports':
        return permissions.includes('VIEW_REPORTS')
      case 'institutions':
        return permissions.includes('MANAGE_INSTITUTIONS')
      case 'students':
        return permissions.includes('MANAGE_STUDENTS')
      case 'syllabus':
        return permissions.includes('MANAGE_SYLLABUS_COURSES')
      case 'exams':
        return permissions.includes('MANAGE_EXAMS_RESULTS')
      case 'certificates':
        return permissions.includes('MANAGE_EXAMS_RESULTS')
      case 'payments':
        return permissions.includes('MANAGE_PAYMENTS')
      case 'commissions':
        return permissions.includes('MANAGE_COMMISSIONS')
      case 'coupons':
        return permissions.includes('MANAGE_COUPONS')
      case 'notifications':
        return permissions.includes('MANAGE_NOTIFICATIONS')
      case 'staff':
        // Staff management is Super Admin-only
        return false
      case 'app-updates':
        // App Updates is Super Admin-only
        return false
      default:
        return false
    }
  }

  const visibleGroups = NAV_GROUPS
    .map((group) => ({ ...group, items: group.items.filter((item) => hasPermission(item.id)) }))
    .filter((group) => group.items.length > 0)

  return (
    <>
      {/* ── Mobile Floating Hamburger Button ──────────────────────── */}
      {isMobile && !mobileOpen && (
        <button
          onClick={() => setMobileOpen(true)}
          className="fixed top-4 left-4 z-40 p-2.5 rounded-xl border flex items-center justify-center transition-all duration-200 active:scale-95 bg-[var(--glass)] border-[var(--glass-brd)] text-[var(--txt)]"
          style={{
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          }}
        >
          <Menu size={22} style={{ strokeWidth: '2px' }} />
        </button>
      )}

      {/* ── Mobile Backdrop Overlay ────────────────────────────────── */}
      {isMobile && (
        <div
          className={`
            fixed inset-0 bg-black/40 backdrop-blur-sm z-40
            transition-opacity duration-300 ease-[var(--ease)]
            ${mobileDrawerOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
          `}
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* ── Sidebar panel ─────────────────────────────────────────── */}
      {/* ── Sidebar panel wrapper ──────────────────────────────────── */}
      <div 
        className="relative h-screen shrink-0 transition-[width] duration-300"
        style={{
          width: isMobile ? '0px' : `${sidebarWidth}px`,
          transitionTimingFunction: 'var(--ease)',
        }}
      >
        <aside
          className={`
            glass flex flex-col h-full w-full select-none overflow-hidden
            border-t-0 border-b-0 border-l-0 border-r border-[var(--glass-brd)]
            transition-[width,transform] duration-300
            ${isMobile
              ? `fixed top-0 bottom-0 left-0 z-50 rounded-none shadow-2xl ${mobileDrawerOpen ? 'translate-x-0' : '-translate-x-full'}`
              : 'static shadow-none'
            }
          `}
          style={{
            width: isMobile ? `${sidebarWidth}px` : '100%',
            transitionTimingFunction: 'var(--ease)',
            background: isMobile ? 'var(--bg-1)' : undefined,
          }}
        >
        {/* ── Logo & Mobile Close Button ────────────────────────── */}
        <div className={`flex items-center transition-all duration-300 ease-[var(--ease)] ${desktopCollapsed ? 'justify-center py-6 px-4' : 'justify-between pt-7 pb-4 px-6'}`}>
          <div className="flex items-center select-none">
            <div className="flex items-center gap-3">
              <div 
                className="h-8 w-8 bg-contain bg-center bg-no-repeat shrink-0 transition-transform duration-300 ease-[var(--ease)]"
                style={{ backgroundImage: `url(${logo})` }}
              />
              <span
                className={`
                  no-sel inline-block text-[28px] font-black leading-none antialiased
                  font-['Plus_Jakarta_Sans',sans-serif] 
                  tracking-[0.8px] bg-gradient-to-r from-[#48d6a2] to-[#22b083] bg-clip-text text-transparent origin-left transition-all duration-300 ease-[var(--ease)]
                  ${desktopCollapsed ? 'opacity-0 max-w-0 translate-x-[-10px] overflow-hidden pointer-events-none' : 'opacity-100 max-w-[150px] ml-1'}
                `}
              >
                DUALON
              </span>
            </div>
          </div>

          {/* X Close — mobile drawer only */}
          {isMobile && (
            <button
              onClick={() => setMobileOpen(false)}
              className={`p-1.5 rounded-lg text-[var(--txt-2)] hover:text-[var(--txt)] transition-all duration-300 ease-[var(--ease)] ${mobileDrawerOpen ? 'opacity-100 pointer-events-auto scale-100' : 'opacity-0 pointer-events-none scale-75'}`}
            >
              <X size={20} />
            </button>
          )}
        </div>

        {/* ── Status indicator ─────────────────────────────────── */}
        <div
          className={`
            mx-5 mb-4 rounded-xl
            bg-[var(--glass)] border border-[var(--glass-brd)]
            items-center gap-[10px] transition-all duration-300 ease-[var(--ease)]
            ${desktopCollapsed ? 'h-0 opacity-0 py-0 px-0 border-none overflow-hidden scale-90' : 'h-[38px] px-[14px] py-[10px] flex'}
          `}
        >
          <span className="pulse-dot w-2 h-2 rounded-full shrink-0 bg-[#33cb98]" />
          <span className="text-[12.5px] font-bold text-[var(--txt-2)] whitespace-nowrap">
            {isSuperAdmin ? 'Super Admin' : 'Staff'} · Live
          </span>
        </div>

        {/* ── Nav sections ─────────────────────────────────────── */}
        <nav className="flex-1 overflow-y-auto overflow-x-hidden scrollbar-none px-5 py-0">
          {showSkeleton ? (
            <SidebarSkeleton desktopCollapsed={desktopCollapsed} />
          ) : (
            visibleGroups.map((group) => (
              <div key={group.title} className="mb-5">
                <div 
                  className={`
                    text-[11px] font-extrabold tracking-[0.8px] uppercase text-[var(--txt-3)] px-3
                    transition-all duration-300 ease-[var(--ease)] origin-left whitespace-nowrap
                    ${desktopCollapsed ? 'opacity-0 max-h-0 pb-0 overflow-hidden' : 'opacity-100 max-h-8 pb-[10px]'}
                  `}
                >
                  {group.title}
                </div>

                <div className="flex flex-col gap-1">
                  {group.items.map((item) => (
                    <NavLink
                      key={item.id}
                      to={item.to}
                      end={item.to === '/dashboard'}
                      className={({ isActive }) =>
                        `nav-item ${
                          isActive
                            ? 'on font-extrabold text-[var(--txt)] shadow-[inset_0_0_0_1px_rgba(51,203,152,0.15)] bg-[rgba(51,203,152,0.06)] [&_svg]:text-[var(--mint-500)] dark:[&_svg]:text-[var(--mint-400)]'
                            : 'hover:bg-[rgba(255,255,255,0.025)] dark:hover:bg-[rgba(255,255,255,0.045)]'
                        } ${desktopCollapsed ? '' : 'hover:translate-x-1'} transition-all duration-200 ease-[var(--ease)]`
                      }
                      style={{
                        justifyContent: desktopCollapsed ? 'center' : 'flex-start',
                        padding: desktopCollapsed ? '12px 0' : '11px 14px',
                        gap: desktopCollapsed ? 0 : undefined,
                      }}
                      title={desktopCollapsed ? item.label : ''}
                      onClick={() => isMobile && setMobileOpen(false)}
                    >
                      <div className="flex items-center justify-center shrink-0 w-5 h-5">
                        <item.icon size={20} style={{ strokeWidth: '1.85px' }} />
                      </div>
                      <span 
                        className={`
                          transition-all duration-300 ease-[var(--ease)] origin-left whitespace-nowrap
                          ${desktopCollapsed ? 'opacity-0 max-w-0 ml-0 flex-none translate-x-[-10px] overflow-hidden' : 'flex-1 opacity-100 max-w-[150px] ml-2'}
                        `}
                      >
                        {item.label}
                      </span>
                    </NavLink>
                  ))}
                </div>
              </div>
            ))
          )}
        </nav>

        {/* ── Footer / Collapse ─────────────────────────────────── */}
        <div className="p-5">
          {/* <div
            className={`
              t-display relative overflow-hidden rounded-2xl border border-[var(--glass-brd)]
              transition-all duration-300 ease-[var(--ease)] origin-bottom
              ${desktopCollapsed ? 'h-0 opacity-0 p-0 mb-0 border-none scale-90' : 'h-auto p-4 mb-[14px]'}
            `}
            style={{ background: 'linear-gradient(140deg, rgba(51, 203, 152, 0.18), rgba(153, 102, 255, 0.18))' }}
          >
            <div className={desktopCollapsed ? 'hidden' : 'block'}>
              <div className="text-sm font-bold mt-2 text-[var(--txt)]">System healthy</div>
              <div className="text-[11.5px] text-[var(--txt-2)] mt-1 leading-[1.45]">
                99.98% uptime · all services operational
              </div>
            </div>
          </div> */}
          {/* Logout button */}
          {/* <button
            className={`nav-item w-full mb-[14px] ${desktopCollapsed ? '' : 'hover:translate-x-1'} transition-all duration-200 ease-[var(--ease)]`}
            onClick={handleLogout}
            disabled={isLoggingOut}
            style={{
              justifyContent: desktopCollapsed ? 'center' : 'flex-start',
              padding: desktopCollapsed ? '12px 0' : '11px 14px',
              gap: desktopCollapsed ? 0 : undefined,
            }}
            title={desktopCollapsed ? 'Log Out' : ''}
          >
            <div className="flex items-center justify-center shrink-0 w-5 h-5" style={{ color: 'var(--rose)' }}>
              <LogOut size={20} style={{ strokeWidth: '1.85px' }} />
            </div>
            <span
              className={`
                transition-all duration-300 ease-[var(--ease)] origin-left whitespace-nowrap
                ${desktopCollapsed ? 'opacity-0 max-w-0 ml-0 translate-x-[-10px] overflow-hidden' : 'opacity-100 max-w-[150px] ml-2'}
              `}
              style={{ color: 'var(--rose)' }}
            >
              {isLoggingOut ? 'Logging out...' : 'Log Out'}
            </span>
          </button> */}


          {/* ── Footer ─────────────────────────────────────────────────── */}
<div className="p-5">
  {/* Logout button - Now occupies the bottom-most slot */}
  <button
    className={`nav-item w-full ${desktopCollapsed ? '' : 'hover:translate-x-1'} transition-all duration-200 ease-[var(--ease)]`}
    onClick={handleLogout}
    disabled={isLoggingOut}
    style={{
      justifyContent: desktopCollapsed ? 'center' : 'flex-start',
      padding: desktopCollapsed ? '12px 0' : '11px 14px',
      gap: desktopCollapsed ? 0 : undefined,
    }}
    title={desktopCollapsed ? 'Log Out' : ''}
  >
    <div className="flex items-center justify-center shrink-0 w-5 h-5" style={{ color: 'var(--rose)' }}>
      <LogOut size={20} style={{ strokeWidth: '1.85px' }} />
    </div>
    <span
      className={`
        transition-all duration-300 ease-[var(--ease)] origin-left whitespace-nowrap
        ${desktopCollapsed ? 'opacity-0 max-w-0 ml-0 translate-x-[-10px] overflow-hidden' : 'opacity-100 max-w-[150px] ml-2'}
      `}
      style={{ color: 'var(--rose)' }}
    >
      {isLoggingOut ? 'Logging out...' : 'Log Out'}
    </span>
  </button>
</div>

          {/* Collapse toggle — desktop only */}
          {/* {!isMobile && (
            <button
              className={`nav-item w-full ${desktopCollapsed ? '' : 'hover:translate-x-1'} transition-all duration-200 ease-[var(--ease)]`}
              onClick={onToggle}
              style={{
                justifyContent: desktopCollapsed ? 'center' : 'flex-start',
                padding: desktopCollapsed ? '12px 0' : '11px 14px',
                gap: desktopCollapsed ? 0 : undefined,
              }}
            >
              <div className="flex items-center justify-center shrink-0 w-5 h-5">
                {collapsed ? (
                  <ArrowRight size={20} style={{ strokeWidth: '1.85px' }} />
                ) : (
                  <ArrowLeft size={20} style={{ strokeWidth: '1.85px' }} />
                )}
              </div>
              <span
                className={`
                  transition-all duration-300 ease-[var(--ease)] origin-left whitespace-nowrap
                  ${desktopCollapsed ? 'opacity-0 max-w-0 ml-0 translate-x-[-10px] overflow-hidden' : 'opacity-100 max-w-[150px] ml-2'}
                `}
              >
                Collapse
              </span>
            </button>
          )} */}
          {/* Version label */}
          {!collapsed && (
            <div className="px-5 py-2 text-[10px] font-bold text-[var(--txt-3)] tracking-wider">
              Version 1.0.1
            </div>
          )}
        </div>
      </aside>

      {/* Floating toggle button — desktop only */}
      {!isMobile && (
        <button
          onClick={onToggle}
          className="absolute top-10 -right-3 z-[60] w-6 h-6 rounded-full border border-[var(--glass-brd)] bg-[var(--bg-2)] text-[var(--txt-2)] hover:text-[var(--txt)] flex items-center justify-center shadow-[0_2px_8px_rgba(0,0,0,0.12)] cursor-pointer hover:scale-105 active:scale-95 transition-all duration-200"
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? (
            <ChevronRight size={14} style={{ strokeWidth: '2.5px' }} />
          ) : (
            <ChevronLeft size={14} style={{ strokeWidth: '2.5px' }} />
          )}
        </button>
      )}
    </div>
  </>
)
}